import React from "react";
import MarketingLayout from "../../components/layout/marketing/MarketingLayout";
import { Mail, MessageCircle, Clock, ShieldCheck } from "lucide-react";

export default function Support() {
    const supportEmail = import.meta.env.VITE_SUPPORT_EMAIL;
    return (
        <MarketingLayout>
            <div className="mx-auto px-8 lg:px-24 py-20 sm:py-24 lg:py-16">
                {/* Header */}
                <div className="border-b border-border-subtle pb-8">
                    <h1 className="text-4xl lg:text-5xl font-bold tracking-tight text-text-primary">
                        Clinic <span className="bg-brand-gradient bg-clip-text text-transparent">Support</span>
                    </h1>
                    <p className="mt-4 text-lg text-text-muted max-w-2xl">
                        We’re here to ensure your clinic runs smoothly. Whether you need technical help or guidance on
                        optimizing Eikos Health, our team is standing by.
                    </p>
                </div>

                <div className="mt-12 grid gap-8 md:grid-cols-2">
                    {/* Email Support */}
                    <div className="rounded-3xl border border-border-subtle bg-white p-8 transition-all hover:shadow-sm">
                        <div className="bg-bg-subtle w-12 h-12 rounded-2xl flex items-center justify-center mb-6">
                            <Mail className="h-6 w-6 text-text-primary" />
                        </div>
                        <h3 className="text-xl font-bold text-text-primary">Email Support</h3>
                        <p className="mt-2 text-sm text-text-muted leading-relaxed">
                            For billing inquiries, account security, or detailed technical documentation requests.
                        </p>
                        <p className="mt-6 text-sm font-bold text-text-primary">{supportEmail}</p>
                    </div>
                </div>

                {/* Response Commitment & Policy */}
                <div className="mt-12 space-y-6">
                    <div className="rounded-3xl bg-bg-subtle/50 border border-border-subtle p-8">
                        <div className="flex flex-col md:flex-row md:items-center gap-6">
                            <div className="bg-white p-4 rounded-2xl shadow-sm">
                                <Clock className="h-6 w-6 text-primary" />
                            </div>
                            <div>
                                <h4 className="text-lg font-bold text-text-primary">Our Commitment to You</h4>
                                <p className="mt-1 text-text-muted leading-relaxed">
                                    We typically respond within <strong>24 business hours</strong>. Critical
                                    infrastructure issues for active clinics are automatically prioritized for immediate
                                    intervention.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* FAQ Quick Link Callout */}
                <div className="mt-20 text-center">
                    <p className="text-text-muted italic">
                        "Eikos Health is designed to be self-managing, but we're here when the unpredictable happens."
                    </p>
                </div>
            </div>
        </MarketingLayout>
    );
}
